import React from 'react';
import Link from 'gatsby-link';

const logo = require('../assets/images/logo/logo-prepared-for-animation.svg');
const logosvg = new Buffer(logo.replace('data:image/svg+xml;base64,', ''), 'base64').toString('utf-8');

import '../templates/blog-post.scss';

const titleStyle = {
  padding: '0 1rem',
  textAnchor: 'middle',
  letterSpacing: '0',
  //fontSize: '2.2rem',
  fontFamily: 'GalanoGrotesqueAlt-Bold, sans-serif',
  textTransform: 'uppercase',
  fontWeight: 800,
  color: 'white',
};

export default function Hero({title, byline, backgroundImage}) {

  const bg = {
    backgroundImage: `url('${backgroundImage}')`,
  };

  return (
    <div className="svg-wrapper-toppest">
      <div className="svg-wrapper-top">
        <div className="header-image" style={bg} data-0="opacity: 0.6;" data-200="opacity: 0.6;" data-500="opacity: 0.1;"></div>
        <Link to="/" title="Alma Developers" className="alma-developers-logo">
          <div className="alma-logo">
            <div className="alma-logo--svg" dangerouslySetInnerHTML={{__html: logosvg}}></div>
          </div>
          <div className="alma-logo-text header-title">
            <span className="header-title__letter">D</span>
            <span className="header-title__letter">e</span>
            <span className="header-title__letter">v</span>
            <span className="header-title__letter">e</span>
            <span className="header-title__letter">l</span>
            <span className="header-title__letter">o</span>
            <span className="header-title__letter">p</span>
            <span className="header-title__letter">e</span>
            <span className="header-title__letter">r</span>
            <span className="header-title__letter">s</span>
          </div>
        </Link>
        <div className="svg-wrapper-middle">
          <div className="svg-wrapper" data-0="transform: translateY(0px);" data-650="transform: translateY(200px);">
            <div>
              <h1 className="article-title--text"><span className="title-highlight">{title}</span></h1>
            </div>
            <div className="article-title--svg">
              <svg id="header-svg" style={{
                width: `${title.replace(' ', '').length*1.5}em`,
                margin: 'auto',
                height: '3.2rem',
                backgroundColor: 'rgba(0,0,0,0.2)',
                textAnchor: 'middle',
              }}>
              <defs>
                <mask id="mask" x="0" y="0" width="100%" height="100%" >
                  <rect id="alpha" x="0" y="0" width="100%" height="100%" style={{fill: 'rgb(255,255,255)'}}/>
                  <text id="title" x="50%" y="0" dy="75%" style={titleStyle}>{title}</text>
                </mask>
              </defs>
              <rect id="base" x="0" y="0" width="100%" height="100%" style={{fill: 'white', mask: 'url(#mask)'}}/>
            </svg>
          </div>
          <div className="blog-post-byline">
            <span className="blog-post-byline__date">{byline}</span>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/hero.jsx